import { Injectable } from '@angular/core';

@Injectable()
export class FooterService {
    private get footer(): HTMLElement {
        return document.getElementById('footer');
    }
    hideFooter() {
        if (this.footer) this.footer.style.display = 'none';
    }
    showFooter() {
        if (this.footer) this.footer.style.display = 'block';
    }
}



// WEBPACK FOOTER //
// ./src/app/footer.service.ts